var _path, _circle, _path2, _path3, _path4, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg033Admin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#fff9dd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 9.333,
    fill: "#ffd200",
    r: 1.333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.833 11.333h-1.667c-1.011 0-1.833.822-1.833 1.833v.334c0 .276.224.5.5.5h4.333c.276 0 .5-.224.5-.5v-.333c.001-1.011-.822-1.834-1.833-1.834z",
    fill: "#ffd200"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.667 18c-.276 0-.5-.224-.5-.5v-.5h-12.334v.5c0 .276-.224.5-.5.5s-.5-.224-.5-.5v-1c0-.276.224-.5.5-.5h13.333c.276 0 .5.224.5.5v1c.001.276-.223.5-.499.5z",
    fill: "#ffe777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16 18c-.276 0-.5-.224-.5-.5v-2.333c0-.276.224-.5.5-.5s.5.224.5.5v2.333c0 .276-.224.5-.5.5z",
    fill: "#ffe777"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffd200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.667 24c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.667 20.167c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.75 23.333h-.917c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.917c.138 0 .25-.112.25-.25s-.112-.25-.25-.25h-.167c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25h.917c.276 0 .5.224.5.5s-.224.5-.5.5h-.917c-.138 0-.25.112-.25.25s.112.25.25.25h.167c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 24c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 20.167c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.083 23.333h-.917c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.917c.138 0 .25-.112.25-.25s-.112-.25-.25-.25h-.167c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25h.917c.276 0 .5.224.5.5s-.224.5-.5.5h-.917c-.138 0-.25.112-.25.25s.112.25.25.25h.167c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 24c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 20.167c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.083 23.333h-.917c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.917c.138 0 .25-.112.25-.25s-.112-.25-.25-.25h-.167c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25h.917c.276 0 .5.224.5.5s-.224.5-.5.5h-.917c-.138 0-.25.112-.25.25s.112.25.25.25h.167c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.333 24c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.333 20.167c-.276 0-.5-.224-.5-.5v-.5c0-.276.224-.5.5-.5s.5.224.5.5v.5c0 .276-.224.5-.5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.417 23.333h-.917c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h.917c.138 0 .25-.112.25-.25s-.112-.25-.25-.25h-.167c-.689 0-1.25-.561-1.25-1.25s.561-1.25 1.25-1.25h.917c.276 0 .5.224.5.5s-.224.5-.5.5h-.917c-.138 0-.25.112-.25.25s.112.25.25.25h.167c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg033Admin);
export default __webpack_public_path__ + "static/media/033-admin.4a5d1d9a6e6a8bc110f5c53783002e54.svg";
export { ForwardRef as ReactComponent };